import { useAppConfiguration, useGraphqlMutation } from '@mews-commander/data-access';
import { graphql } from '@mews-commander/guest-profile';

const MergeGuestProfilesMutation = graphql(`
    mutation mergeGuestProfilesResult(
        $sourceId: UUID!
        $targetId: UUID!
        $guestProfileDetails: GuestProfileMergeUpdatesInput
    ) {
        mergeGuestProfiles(sourceId: $sourceId, targetId: $targetId, guestProfileDetails: $guestProfileDetails) {
            success
        }
    }
`);

interface MutationOptions {
    onSuccess?: () => void;
    onError?: () => void;
}

export const useMergeGuestProfiles = (options: MutationOptions) => {
    const { guestProfileApiUrl } = useAppConfiguration();
    return useGraphqlMutation(
        guestProfileApiUrl,
        {
            document: MergeGuestProfilesMutation,
        },
        options
    );
};
